import React from 'react';

const FALLBACK_BASE =
  process.env.REACT_APP_BASE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'https://ecowaycabs.com');
const FALLBACK_IMAGE_PATH = '/ecoway-logo.jpeg';

// React 19 hoists <title>, <meta> and <link> tags to <head> automatically.
// Values resolve in this order: admin SEO config (seo[pageKey]) -> direct props -> page defaults.
export const Seo = ({
  title,
  description,
  keywords,
  image,
  noindex = false,
  path = '/',
  jsonLd = null,
  pageKey,
  seo,
  defaults = {},
}) => {
  const cfg = (pageKey && seo && seo[pageKey]) || {};
  const base = (seo && seo.canonical_base) || FALLBACK_BASE;

  const resolvedTitle = cfg.title || title || defaults.title;
  const resolvedDesc = cfg.description || description || defaults.description;
  const resolvedKeywords = cfg.keywords || keywords || defaults.keywords;
  const resolvedNoindex = (cfg.noindex ?? noindex) === true;

  let resolvedImage =
    cfg.og_image || (seo && seo.default_og_image) || image || defaults.image || `${base}${FALLBACK_IMAGE_PATH}`;
  if (resolvedImage && resolvedImage.startsWith('/')) resolvedImage = `${base}${resolvedImage}`;

  const url = `${base}${path}`;

  return (
    <>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDesc} />
      {resolvedKeywords && <meta name="keywords" content={resolvedKeywords} />}
      <meta name="robots" content={resolvedNoindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ecoway Cabs" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={resolvedImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDesc} />
      <meta name="twitter:image" content={resolvedImage} />

      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd).replace(/</g, '\\u003c') }}
        />
      )}
    </>
  );
};

export default Seo;
